/**
 * BFF `/_data/:routeId` transport headers — the ONE declaration of the
 * header names the client dataStrategy (`app/entry-client.tsx`) sends and
 * the server handler (`server/bff.ts`) reads (audit round-4 W4; the name
 * was a free literal on both sides of the wire).
 *
 * Runtime module on purpose (bff-contract.ts stays type-only).
 */

/**
 * Carries the ACTUAL route URL (e.g. `/en/blog/x`) alongside the
 * `/_data/:routeId` transport URL, so loaders run against the real route
 * and the locale seam sees the prefix.
 */
export const BFF_ROUTE_URL_HEADER = 'X-Route-URL';
